import {getIn} from 'formik';

export function getStyles(errors, fieldName) {
    if (getIn(errors, fieldName)) {
        return {
            border: '1px solid red',
        };
    }
}
